<!--
 @description dashBoard mixin组件
 @author huangzhijie
 @date 2018/11/19
-->
<script>
import ViewBiz from '@/logic/intelligentMonitor/viewBiz'
import ITDeviceMonitorBiz from '@/logic/intelligentMonitor/ITDeviceMonitorBiz'
import DashboardBiz from '@/logic/intelligentMonitor/dashBoardBiz'
import TimeFormat from '@/utils/timeFormat'

const TYPE_MAP = {
  'Histogram': 'BAR',
  'Area': 'AREA',
  'Line': 'LINE',
  'Pie': 'PIE'
}

export default {
  components: {
  },
  data () {
    return {
      in_chartListDataRaw: [],
      in_chartListData: [],
      in_viewList: []
    }
  },
  computed: {
  },
  watch: {
    'in_chartListDataRaw': {
      deep: true,
      handler: function (val) {
        const res = []
        if (this.in_chartListDataRaw.length > 0) {
          this.in_chartListDataRaw.map((item) => {
            if (item.chartId) {
              res[item.index] = item
            }
          })
        }
        for (let i = 0; i < res.length; i++) {
          // 因为有的图表不是按顺序出现，需要把数组的空位设置为{}，否则为 undefined
          if (res[i] === undefined) res[i] = {}
        }
        this.in_chartListData = res
      }
    },
    'in_chartListData': {
      deep: true,
      handler: function (val) {
        this.in_viewList = []
        val.map((item, index) => {
          if (Object.keys(item).length !== 0) {
            const viewItem = this.in_viewList[index]
            if (viewItem) {
              viewItem.style.width = item.style.width + 'px'
              viewItem.style.height = item.style.height + 'px'
            } else {
              this.in_viewList[index] = {
                viewId: item.chartId,
                style: {
                  width: item.style.width + 'px',
                  height: item.style.height + 'px',
                  screenWidth: window.screen.width,
                  index: index
                }
              }
            }
          }
        })
      }
    }
  },
  methods: {
    in_getChartData ({
      group, kpiKey, appName, groupField,
      startTime = TimeFormat.getToday(), endTime = new Date().getTime()}) {
      let searchData = {
        startTime: startTime,
        endTime: endTime,
        group: group,
        kpiKey: kpiKey,
        appName: appName
      }
      if (groupField) {
        searchData.groupField = groupField
      }
      return ITDeviceMonitorBiz.getChartData(searchData)
    },
    in_getChartDataCustomData (id) {
      return ViewBiz.getSourceData({
        id: id
      })
    },
    in_handerCustomData (data, x, y) {
      if (data.data instanceof Array) {
        return data.data
      } else {
        // 把数据转换为指定字段
        try {
          const dataKey = y[0].field.split('.')
          let dd = data.data
          for (var i = 1; i < dataKey.length - 1; i++) {
            dd = dd[dataKey[i]]
          }
          if (dd instanceof Array) {
            return dd
          } else {
            return []
          }
        } catch (err) {
          this.$message({
            message: this.$t('view.drawFail'),
            type: 'error'
          })
        }
      }
    },
    in_resetData () {
      this.in_chartListDataRaw = []
      this.in_viewList = []
    },
    in_checkViewExist (id) {
      for (let i = 0; i < this.in_viewList.length; i++) {
        const item = this.in_viewList[i]
        if (item.viewId === id) {
          return true
        }
      }
      return false
    },
    // 添加一个图表
    async in_addOneChartData ({
      id, name, dataSource, appName, group, kpiKey,
      startTime, endTime, index,
      width = 402, height = 262
    }) {
      const chartItem = {
        title: name,
        chartId: id
      }
      var _data, x, y, isSeries

      if (index === undefined) {
        index = this.in_chartListDataRaw.length
      }

      await ViewBiz.findViewById({id: id}).then((data) => {
        chartItem.type = TYPE_MAP[data.type]

        // name = data.name
        x = data.param.x
        y = data.param.y
        isSeries = data.param.series
      })

      if (dataSource) {
        try {
          const d = await this.in_getChartDataCustomData(dataSource.id)
          if (d.resultCode && d.resultCode !== '00000000') {
            this.$message({
              message: `${this.$t('view.dataSourceError')}: ${d.resultDesc}`,
              type: 'error'
            })
            return
          } else {
            _data = this.in_handerCustomData(d, x, y)
          }
        } catch (err) {
          console.error(err)
        }
      } else {
        if (isSeries) {
          const groupField = isSeries.replace(/(data\.)/, '') // 去掉data.
          await this.in_getChartData({
            appName,
            group,
            kpiKey,
            groupField,
            startTime,
            endTime
          }).then((d) => {
            _data = d
          })
        } else {
          await this.in_getChartData({
            appName,
            group,
            kpiKey,
            startTime,
            endTime
          }).then((d) => {
            _data = d
          })
        }
      }
      const chartData = ViewBiz.viewHelper.chartDataHandle({
        name: name,
        data: _data,
        x: x,
        y: y,
        isSeries: isSeries
      })

      chartItem.chartData = chartData
      chartItem.index = index
      if (isNaN(width)) width = width.replace(/\D+/, '')
      if (isNaN(height)) height = height.replace(/\D+/, '')
      chartItem.style = {
        width: width,
        height: height
      }

      this.in_chartListDataRaw.push(chartItem)
    },
    // 保存
    in_save (saveData) {
      return DashboardBiz.saveBoard(saveData)
    },
    in_update (updateData) {
      return DashboardBiz.updateBoard(updateData)
    },
    // 去掉一个图表
    in_delete (index) {
      for (let i = this.in_chartListDataRaw.length - 1; i >= 0; i--) {
        const item = this.in_chartListDataRaw[i]
        if (item.index === index) {
          this.in_chartListDataRaw.splice(i, 1)
        } else if (item.index > index) {
          item.index = item.index - 1
        }
      }
    },
    // 查dashboard
    in_findDashBoad (id) {
      return DashboardBiz.findBoardById({id})
    },
    in_updateTimer ({dashId, data, type}) {
      return DashboardBiz.setDashTimer({dashId, data, type})
    }
  },
  mounted () {
  }
}
</script>